import React, { useContext } from "react";
import { PageHero } from "@/components/common/SectionHeading";
import { SettingsContext } from "@/components/layout/SettingsContext";
import { ExternalLink } from "lucide-react";

export default function Portal() {
    const s = useContext(SettingsContext);
    return (
        <div data-testid="portal-page">
            <PageHero eyebrow="Student portal" title="LNL Student Portal" description="Current students access grades, records and enrollment information through the student portal." breadcrumbs={[{label:"Home",to:"/"},{label:"Portal"}]} />
            <section className="py-10 bg-white">
                <div className="lnl-container max-w-2xl">
                    <div className="lnl-card p-6">
                        <div className="font-heading font-bold text-lnl-charcoal">Open the Student Portal</div>
                        <div className="text-sm text-lnl-gray mt-1">The portal opens in a new tab. Sign in with your LNL portal credentials.</div>
                        <a href={s?.portal_url} target="_blank" rel="noopener noreferrer" className="mt-4 lnl-btn-primary" data-testid="portal-link">Open Portal <ExternalLink className="h-4 w-4" /></a>
                    </div>
                </div>
            </section>
        </div>
    );
}
